function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS ToggleField INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { fieldProps, getPreferredProp } from "../../../Form/utils";
function UUToggleField(props) {
  var disabled = props.disabled,
    fullWidth = props.fullWidth,
    hint = props.hint,
    id = props.id,
    label = props.label,
    labelPosition = props.labelPosition,
    style = props.style,
    value = props.value,
    valueText = props.valueText;
  var containerClass = classNames('space-x-2', {
    'w-full': fullWidth,
    'inline-flex items-center': !hint,
    flex: hint
  }, style.container);
  var labelClass = classNames('normal-case text-sm text-text-blue font-regular-font tracking-normal', {
    'w-1/2': fullWidth,
    'mt-0.5': hint
  }, style.label);
  var buttonClass = classNames('w-10 h-6 rounded-xl transition-all duration-500 focus:outline-solid-offset', {
    'bg-action-blue border-action-blue': value,
    'hover:bg-deep-blue': value && !disabled,
    'bg-medium-grey border-medium-grey': !value,
    'hover:bg-dark-grey': !value && !disabled,
    'bg-opacity-50 cursor-default': disabled
  }, style.button);
  var spanClass = classNames('inline-block h-6 w-6 bg-white border-solid border-2 rounded-xl', {
    'transform translate-x-2 border-action-blue': value,
    'hover:border-deep-blue': value && !disabled,
    'transform -translate-x-2 border-medium-grey': !value,
    'hover:border-dark-grey': !value && !disabled,
    'border-opacity-50': disabled
  });
  var toggleClass = classNames('flex items-center', {
    'flex-row-reverse justify-end': labelPosition === 'left'
  }, style.toggle);
  var valueTextClass = classNames('text-sm', {
    'pr-2': labelPosition === 'left',
    'pl-2': labelPosition === 'right',
    'opacity-50': disabled
  });
  var hintClass = classNames('text-xs italic leading-4 pt-2 text-medium-grey', {
    'opacity-50': disabled
  }, style.hint);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass,
    "data-testid": "".concat(id, "-toggle-field__wrapper"),
    id: "".concat(id, "-toggle-field__wrapper")
  }, label && /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    htmlFor: "".concat(id, "-toggle-field__button")
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "".concat(fullWidth ? 'w-1/2' : '', " ").concat(style.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: toggleClass
  }, /*#__PURE__*/React.createElement("button", {
    "aria-hidden": true,
    className: buttonClass,
    "data-testid": "".concat(id, "-toggle-field__button"),
    id: "".concat(id, "-toggle-field__button"),
    onClick: getPreferredProp(props, 'onClick'),
    onBlur: getPreferredProp(props, 'onBlur'),
    onFocus: getPreferredProp(props, 'onFocus'),
    tabIndex: 0,
    disabled: disabled,
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "".concat(label, " toggle: ").concat(valueText)), hint && /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "toggle hint: ".concat(hint)), /*#__PURE__*/React.createElement("span", {
    className: spanClass
  })), valueText && /*#__PURE__*/React.createElement("div", {
    className: valueTextClass
  }, valueText)), hint && /*#__PURE__*/React.createElement("div", {
    className: hintClass,
    "data-testid": "".concat(id, "-toggle-field__hint"),
    id: "".concat(id, "-toggle-field__hint")
  }, hint)));
}
UUToggleField.propTypes = _objectSpread({
  /** Is the field disabled? */
  disabled: PropTypes.bool,
  /** Should the field span the full width of the page? */
  fullWidth: PropTypes.bool,
  /** id for reference */
  id: PropTypes.string.isRequired,
  /** Help text displayed below the button */
  hint: PropTypes.string,
  /** label text for toggle field */
  label: PropTypes.string,
  /** Position of the label */
  labelPosition: PropTypes.oneOf(['right', 'left']),
  /** Add tailwind styles to elements */
  style: PropTypes.shape({
    container: PropTypes.string,
    button: PropTypes.string,
    hint: PropTypes.string,
    label: PropTypes.string,
    toggle: PropTypes.string,
    wrapper: PropTypes.string
  }),
  /** Value of the toggle (ex: true/false) */
  value: PropTypes.bool.isRequired,
  /** Text displayed to the left or right of button */
  valueText: PropTypes.string
}, fieldProps);
UUToggleField.defaultProps = {
  disabled: false,
  fullWidth: false,
  hint: '',
  label: '',
  labelPosition: 'right',
  style: {
    container: '',
    button: '',
    hint: '',
    label: '',
    toggle: '',
    wrapper: ''
  },
  valueText: ''
};
export default UUToggleField;